import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useSales } from "@/lib/sales";

// THE STAGE 2 SWITCH (Admin only, on the Permissions page because switching it on is what puts the six Sales
// permissions in the grid). Off = every Sales door is absent for everyone, Admin included. Every switch is logged.
export function SalesSwitch() {
  const sales = useSales();
  const [busy, setBusy] = useState(false);
  if (!sales.ready || !sales.canSwitch) return null;
  const flip = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/sales/switch", { on: !sales.on });
      toast.success(data.on ? "Stage 2 — Sales Management is switched ON." : "Stage 2 — Sales Management is switched OFF.");
      await sales.reload();
      window.location.reload();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="sales-switch" className={`rounded-xl border-2 p-3 mb-4 flex flex-wrap items-center gap-3 ${sales.on ? "border-emerald-300 bg-emerald-50" : "border-slate-300 bg-slate-50"}`}>
      <div className="flex-1 min-w-[220px] text-sm">
        <b data-testid="sales-switch-state">Stage 2 — Sales Management is {sales.on ? "ON" : "OFF"}.</b>{" "}
        {sales.on ? "The Sales menu, Sales Management and its six permissions are in use." : "Nobody sees any part of it — its six permissions appear here once it is on."}
      </div>
      <button type="button" data-testid="sales-switch-toggle" disabled={busy} onClick={flip}
        className="h-11 px-4 rounded-lg bg-[#1F1F1F] hover:bg-black text-white text-sm font-bold disabled:opacity-40">
        Switch {sales.on ? "off" : "on"}</button>
    </div>
  );
}
